"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function mona(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.6498 10.0612L16.581 5.25073L14.4833 8.56123C12.8524 8.16746 11.1513 8.16746 9.52051 8.56123L7.42876 5.25073L6.35626 10.0612C5.20501 10.9822 4.50226 12.186 4.50226 13.5075C4.50226 16.4025 7.85926 18.7492 12 18.7492C16.1408 18.7492 19.4978 16.4017 19.4978 13.5075C19.497 12.186 18.8003 10.9822 17.649 10.0612H17.6498ZM7.83376 12.2632H7.33426L8.55451 10.8562H9.44251L7.83376 12.2632ZM11.9618 15.7012L9.88726 12.0472L10.3995 11.7547L10.8623 12.5685H13.128L13.611 11.751L14.118 12.0525L11.9618 15.7012ZM16.1715 12.2632L14.562 10.8562H15.456L16.6748 12.2632H16.1715ZM11.9715 14.5245L11.1968 13.1595H12.7778L11.9715 14.5245Z", fill: color }));
}
exports["default"] = mona;
//# sourceMappingURL=mona.js.map